angular.module('cfn').directive('cfnInputDateperiod', [
  'i18nFilter',
  function(i18nFilter) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        class: '@',
        readonly: '=',
        required: '@',
        change: '&',
        isdisabled: '&',
        uiDefault: '@',
        param: '@',
        text: '@'
      },
      replace: true,
      template:
        '<div class="datePeriodDisplay">' +
        '<input class="{{class}}" ng-change="daysChange()" type="number" ng-disabled="isdisabled()" class="{{class}}" ' +
        'type="number" ng-model="days" max="{{max}}" min="{{min}}"><span class="days">{{text}}</span><span class="date">' +
        '{{resultingDate|date:"shortDate"}}</span></div>',
      link: function(scope, element, attrs) {
        var cachePath = 'fip.' + attrs.model;
        attrs.$observe('uiMax', function(val) {
          scope.max = angular.isDefined(val) ? val : '999';
        });
        attrs.$observe('uiMin', function(val) {
          scope.min = angular.isDefined(val) ? val : '0';
        });
        scope.getReferenceDate = function() {
          scope.text = i18nFilter('fe.booking.fip.core.days');
          if (scope.param) {
            var numeric = parseInt(scope.param);
            if (isNaN(numeric)) {
              var date = new Date(scope.param);
            } else {
              console.debug('reference date', numeric);
              return new Date(numeric);
            }
          } else {
            return new Date();
          }
        };

        scope.daysChange = function() {
          if (scope.days != undefined && scope.days != null) {
            var date = scope.getReferenceDate();
            date.setDate(date.getDate() + parseInt(scope.days));
            // store model as number
            scope.model = date.getTime();
            setUiValue(cachePath, scope.days);
          } else {
            scope.model = null;
          }
        };

        scope.$watch(
          'model',
          function() {
            try {
              if (scope.model) {
                var date = new Date(scope.model);
                var now = scope.getReferenceDate();
                var timeDiff = Math.abs(date.getTime() - now.getTime());
                scope.days = Math.round(timeDiff / (1000 * 3600 * 24));
                scope.resultingDate = date;
              } else {
                scope.resultingDate = null;
              }
            } catch (e) {
              scope.days = 0;
              scope.resultingDate = new Date();
              console.error('Exception', e, scope.model);
            }
          },
          true
        );

        if (cachePath && !scope.model) {
          var cached = getUiValueInt(cachePath);
          if (cached != undefined && cached != null) {
            scope.days = cached;
            scope.daysChange(); // set initial value correctly
          } else if (scope.uiDefault) {
            scope.days = scope.uiDefault;
            console.debug('Using ui default', scope.uiDefault);
            scope.daysChange(); // set initial value correctly
          }
        }

        scope.$watch('param', function() {
          scope.daysChange();
        });
      }
    };
  }
]);
